import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { INews } from "../shared/models/news.model";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class NewsData {

  constructor(
    private afDb: AngularFireDatabase,
    private tracking: TrackingProvider,
  ) { }

  public getNewsByClient(client: string): Observable<INews[]> {
    return this.afDb.list<INews>(`Clients/${client}/Interactivity/News`).
      valueChanges();
  }

  public getNewByClient(client: string, newsId: string): Observable<INews> {
    return this.afDb.object<INews>(`Clients/${client}/Interactivity/News/${newsId}`).
      valueChanges();
  }

  public createOrUpdateNews(
    client: string,
    object: INews,
    id: string = "",
  ) {
    if (!id) {
      id = this.afDb.createPushId();
      object.created_at = new Date().getTime();
    } else {
      object.update_at = new Date().getTime();
    }

    object.id = id;
    return new Promise((res, rej) => {
      this.afDb.database
        .ref(`Clients/${client}/Interactivity/News/${id}/`)
        .update(object)
        .then(() => {
          this.tracking.trackEntity(_TRACKING_ENTITIES.news, id, client, object.eventId, object, "Creacion/actualizacion news general");

          return res();
        })
        .catch(e => {
          return rej(e);
        });
    });
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/news.ts